import React, { Component } from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import {
  MP_CLICKED_READ_REVIEWS_EVENT_NAME, MP_CLICKED_TESTIMONIALS_ARROW_EVENT_NAME,
  MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';
import HomeSubcatSelect from 'marketing/containers/hero_subcat_select';
import CategoriesSlider from 'landing_pages/containers/categories';
import TestimonialSlider from 'marketing/common/testimonial_slider';
import Featured from 'marketing/common/featured';
import Support from 'marketing/containers/support';
import FloatingImages from 'marketing/components/floating_images';
import How3 from 'landing_pages/components/how_3';

const BRAND_ICONS = [
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/fcb-logo-transparent-60x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/cpb-logo-transparent-200x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/bbh-logo-transparent-60x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/shift-communications-logo-transparent-200x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/p%26g-2018-logo-transparent-60x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/amazon-logo-transparent-60x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/lg-logo-transparent-200x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/starbucks-logo-transparent-60x60.png",
  "https://s3.amazonaws.com/crowdspring3-assets/marketing/barilla-logo-transparent-200x60.png"
];

const TESTIMONIALS = [
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_cori-newlander.jpg',
    title: 'I can\'t speak highly enough of crowdspring.',
    quote: 'I started with a small budget and some boring content, and within a short time, I had some amazing designs to choose from. The hardest part was choosing one!',
    author: 'Cori Newlander, City of Santa Monica',
  },
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_christina-catalano.jpg',
    title: 'I am thrilled with the professional and eye-catching final design!',
    quote: 'I had over 100 entries that were creative, unique, and specific to my design ideas. I would asbsolutely recommend crowdspring to any professional who doesn’t have an in-office creative team.',
    author: 'Christina Catalano, Catalano & Associates',
  },
  {
    image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonial_jeff-knowles.jpg',
    title: 'Crowdspring will be my first stop for my future creative needs.',
    quote: 'I’ve had great success with crowdspring, using the website to both redesign an existing website and to create a website from scratch. Both projects produced a large number of high quality design options.',
    author: 'Jeff Knowles',
  },
];


const HomeContent = () => {
  return (
    <div className="hero-content">
      <section className="hero">
        <div className="row hero-row">
          <div className="small-16 large-8 columns">
            <div className="hero-container">
              <h2 className="hero-title">
                A secret weapon for top agencies, <br className="hide-for-small-only" />
                a smarter design solution for you.
              </h2>
              <p className="hero-text">
                Crowdspring helps you grow your business with <br className="hide-for-small-only" />
                affordable, high-quality custom logos, names, print and <br className="hide-for-small-only" />
                web design, product design, and packaging design.
              </p>
              <HomeSubcatSelect />
            </div>
          </div>
          <div className="hide-for-large small-16 columns">
            <div className="artwork-container text-center">
              <img className="hero-art" src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-illustration-homepage-purple-content-only.png" />
            </div>
          </div>
        </div>
      </section>
      <section className="block block-trusted-by">
        <div className="row columns small-16">
          <h4 className="text-center">Trusted by top agencies and Brands, including:</h4>
        </div>
        <div className="row align-center align-middle">
          { BRAND_ICONS.map((url, i) => (
          <div className="column small-4 large-expand text-center" key={i}>
            <img src={url} />
          </div>
          )) }
        </div>
      </section>
      <section className="block block-brand">
        <div className="row columns">
          <div className="block-header">
            <h2>Build a brand your customers love</h2>
          </div>
        </div>
        <div className="row small-up-1 large-up-3">
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-guarantee-illustration-homepage.jpg" />
              </div>
              <h3>Guarantee?</h3>
              <h3>You betcha...</h3>
              <p>
                If you're not 100% happy with your design project, we'll promptly refund all
                of your money.
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-contract-illustration-homepage.jpg" />
              </div>
              <h3>IP protection?</h3>
              <h3>Ahead of the pack...</h3>
              <p>
                Industry-leading IP protections. You will own your winning design and you can
                use it any way you like.
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="item">
              <div className="text-center">
                <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-choice3-illustration-homepage.png" />
              </div>
              <h3>Variety and choice?</h3>
              <h3>Raising the bar...</h3>
              <p>
                220,000+ creatives from 195 countries. Work with them in a way that works for you.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="block block-categories">
        <div className="row columns">
          <div className="block-header">
            <h2>Whatever you need, we've got you covered.</h2>
          </div>
        </div>
        <CategoriesSlider sortByPopularity={true} />
        <div className="row columns text-center">
          <Link to="/categories/">See all project categories</Link>
        </div>
      </section>
      <FloatingImages />
      <How3 />
      <section className="block block-scales">
        <div className="row columns">
          <div className="block-header">
            <h2>Crowdspring scales to meet the needs of any business</h2>
          </div>
        </div>
        <div className="row">
          <div className="columns small-16 large-8 text-center">
            <h3>Manage an agency or consultancy?</h3>
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-agency-illustration-optimized.png" />
            <p>
              Many of the world's best boutiques to large agencies leverage crowdspring
              to innovate their businesses and increase client choice. Do more, in less time,
              with fewer capital expenses.
            </p>
            <Link to="/agencies/">Learn more</Link>
          </div>
          <div className="columns small-16 large-8 text-center">
            <h3>Own or operate a business?</h3>
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/cs-business-illustration-optimized.png" />
            <p>
              Company name, logo, web design, and more - whatever you need, we've got it.
              Our flexible pricing is perfect for businesses of any size. Know up front
              exactly what you'll pay.
            </p>
            <Link to="/how-it-works/">Learn more</Link>
          </div>
        </div>
      </section>
      <TestimonialSlider
        title={<h2>Loved by over 60,000 agencies and businesses around the world</h2>}
        items={TESTIMONIALS}
        linkEventTracking={{
          eventName: MP_CLICKED_READ_REVIEWS_EVENT_NAME,
          eventData: {
            pageName: "Homepage",
            pageArea: "Testimonial slider",
          }
        }}
        arrowEventTracking={{
          eventName: MP_CLICKED_TESTIMONIALS_ARROW_EVENT_NAME,
          eventData: {
            pageName: "Homepage",
            pageArea: "Testimonial slider",
          }
        }}
      />
      <Featured showAdsWeek={true} />
      <section className="block block-easy-to-start">
        <div className="row columns small-16 large-10 text-center">
          <div className="easy-to-start">
            <span className="text">
              It's easy to get started. And it's guaranteed. Two things everyone loves.
            </span>
            <Link to="/start-a-project/" className="btn btn-primary">Get started</Link>
          </div>
        </div>
      </section>
      <Support
        consultationEventTracking={{
          eventName: MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME,
          eventData: {
            pageName: "Homepage",
            version: "english",
            pageArea: "Support footer",
          }
        }}
      />
    </div>
  );
}

export default HomeContent;



// WEBPACK FOOTER //
// ./marketing/components/home_content.jsx